module.exports = __webpack_public_path__ + "img/lootbox-boxes-bg.f2e13ede.svg";